import React, { useEffect, useRef, useState } from 'react';
import { withReportChips } from '../../reportChips';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import GenericTable from '../../../../Components/GenericTable';
import { Pagination } from '@material-ui/lab';
import CustamizedFilters from '../../../../Components/CustamizedFilters';
import {
    GetApp as GetAppIcon,
    Print,
} from '@material-ui/icons';
import { CircularProgress, IconButton, Input } from '@material-ui/core';
import FilterModal from '../FilterModal';

const useStyles = makeStyles((theme) => ({
    actionIconBtn: {
        width: 36,
        height: 36,
        borderRadius: 8,
        border: '1px solid #e7ebf0',
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: 'rgba(61, 125, 221, 0.06)',
            borderColor: '#d5dde8',
        },
    },
    tableWrapper: {
        width: '100%',
        overflowX: 'auto',
        marginTop: theme.spacing(1),
    },
    paginationRow: {
        marginTop: 22,
        marginBottom: 20,
        [theme.breakpoints.down('xs')]: {
            marginTop: 16,
            marginBottom: 16,
        },
    },
    paginationWrap: {
        display: 'flex',
        margin: '0 auto',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 8,
        [theme.breakpoints.down('xs')]: {
            padding: '0 8px',
        },
    },
    goToPageInput: {
        minWidth: 110,
        width: 110,
        marginLeft: 15,
        borderRadius: 8,
        padding: 8,
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
            minWidth: 90,
            width: 90,
        },
    },
}));

const DetailsAnalyticsTabData = ({ 
    title, 
    filters, 
    allFilterState, 
    handleChange, 
    type, 
    pageName,
    columns, 
    loading, 
    handleItemClick, 
    list,
    label, 
    handlePageChange, 
    handleSubmitFilter,
    handleClearFilters,
    handleGoToPage,
    handleDownload,
    downloadReportLoading,
    handlePrint,
    printReportLoading
}) => {
 
    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState([]);
    const [goToPage, setGoToPage] = useState('');
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    useEffect(() => {
        setGoToPage('');
    }, [list]);

    const handleClose = value => {
        setOpen(false);
        setSelectedValue(value);
    };

    const componentRef = useRef();

    // Use new pagination structure from filters.pagination
    const totalPages = parseInt(filters?.pagination?.total_pages) || 1;
    const currentPage = parseInt(filters?.pagination?.page) || 1;
    const totalEntries = parseInt(filters?.pagination?.total_entries) || 0;

    const filterHeaderActions = (
        <>
            <IconButton className={classes.actionIconBtn} onClick={handlePrint} aria-label="Print">
                {printReportLoading ? (
                    <CircularProgress color="primary" size={16} />
                ) : (
                    <Print color="primary" fontSize="small" />
                )}
            </IconButton>
            <IconButton className={classes.actionIconBtn} aria-label="ExportCSV" onClick={handleDownload}>
                {downloadReportLoading ? (
                    <CircularProgress color="primary" size={16} />
                ) : (
                    <GetAppIcon color="primary" fontSize="small" />
                )}
            </IconButton>
        </>
    );

    return (
        <>
            <Grid container ref={componentRef}>
                <Grid item xs={12}>
                    <CustamizedFilters
                        type={type}
                        filters={filters}
                        pageName={pageName}
                        allFilterState={allFilterState}
                        handleChange={handleChange}
                        handleSubmitFilter={handleSubmitFilter}
                        handleClearFilters={handleClearFilters}
                        headerActions={filterHeaderActions}
                        loading={loading}
                    />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} className={classes.tableWrapper}>
                    <GenericTable
                        columns={withReportChips(columns)}
                        loading={loading}
                        left={true}
                        handleItemClick={handleItemClick}
                        list={list}
                        applyMinWidth={false}
                        label={label}
                        noDataMessage="No record found"
                    />
                </Grid>
            </Grid>
            <Grid container className={classes.paginationRow}>
                <div className={classes.paginationWrap}>
                    {totalEntries > 0 && (
                        <Pagination
                            size={isMobile ? 'small' : 'medium'}
                            onChange={(event, page) => handlePageChange(page)}
                            showFirstButton 
                            showLastButton
                            count={totalPages}
                            variant="outlined"
                            page={currentPage}
                            shape="rounded"
                        />
                    )}
                    {totalEntries > 5 && handleGoToPage && (
                        <Input
                            label={"Go to Page"}
                            disableUnderline
                            className={classes.goToPageInput}
                            placeholder='Page'
                            onKeyDown={evt => {
                                if (evt.key === 'Enter' && goToPage) {
                                    handleGoToPage(parseInt(goToPage));
                                }
                            }}
                            onChange={evt => {
                                const val = parseInt(evt.target.value);
                                if(val && val <= totalPages && val > 0){
                                    setGoToPage(val);
                                } else {
                                    setGoToPage('');
                                }
                                return null;
                            }}
                            type={'number'}
                            value={goToPage}
                        />
                    )}
                </div>
            </Grid>
            <FilterModal
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                allColumns={columns}
            />
        </>
    );
}

export default DetailsAnalyticsTabData;